document.addEventListener('rebuy:smartcart.show', (event) => {
    console.log('Rebuy cart ready event fired');

    // Find the add-on title element
    const addOnTitle = document.querySelector('.product-title-sca');
    console.log('Found addOnTitle element:', addOnTitle);

    if (!addOnTitle) {
        console.error('Could not find element with class .product-title-sca');
        return;
    }

    // Check if information button already exists to prevent duplicates
    let informationButtonElement = document.getElementById('cs-info-button-1605');

    if (!informationButtonElement) {
        // Create the information button only if it doesn't exist
        informationButtonElement = document.createElement('button');
        informationButtonElement.id = 'cs-info-button-1605'; // Set the ID for the modal trigger
        informationButtonElement.classList.add('information-button');
        informationButtonElement.innerHTML = `
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="300" height="300">
            <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                <g>
                    <path d="M437.02,74.98C388.667,26.628,324.381,0,256,0C187.62,0,123.333,26.628,74.98,74.98C26.628,123.333,0,187.619,0,256s26.628,132.667,74.98,181.02C123.333,485.372,187.62,512,256,512c68.381,0,132.667-26.628,181.02-74.98S512,324.381,512,256S485.372,123.333,437.02,74.98z M256,478.609c-122.746,0-222.609-99.862-222.609-222.609S133.254,33.391,256,33.391S478.609,133.254,478.609,256S378.746,478.609,256,478.609z" fill="#003057" fill-opacity="1" data-original-color="#000000ff" stroke="none" stroke-opacity="1" />
                </g>
                <g>
                    <rect x="231.58" y="203.776" width="49.208" height="192.412" fill="#003057" fill-opacity="1" data-original-color="#000000ff" stroke="none" stroke-opacity="1" />
                </g>
                <g>
                    <rect x="231.58" y="128.134" width="49.208" height="48.839" fill="#003057" fill-opacity="1" data-original-color="#000000ff" stroke="none" stroke-opacity="1" />
                </g>
            </g>
        </svg>
        `;

        console.log('Created button element:', informationButtonElement);

        // Append the button to the add-on title
        try {
            addOnTitle.appendChild(informationButtonElement);
            console.log('Successfully appended button to addOnTitle');
        } catch (error) {
            console.error('Error appending button:', error);
        }
    } else {
        console.log('Information button already exists, skipping creation');
    }

    // Ensure insurance checkbox is checked
    ensureInsuranceCheckboxChecked();

    // Initialize modal functionality
    initializeInsuranceModal();
});

// Function to ensure insurance checkbox is always checked when cart opens
function ensureInsuranceCheckboxChecked() {
    // Wait a bit for the cart to fully load
    setTimeout(() => {
        const insuranceCheckbox = document.querySelector('#sca-cart-addon input[type="checkbox"]');

        if (insuranceCheckbox) {
            // Check if the checkbox is not checked
            if (!insuranceCheckbox.checked) {
                console.log('Insurance checkbox not checked, checking it now');
                insuranceCheckbox.checked = true;

                // Trigger the change event to ensure the cart logic runs
                const changeEvent = new Event('change', { bubbles: true });
                insuranceCheckbox.dispatchEvent(changeEvent);
            } else {
                console.log('Insurance checkbox already checked');
            }
        } else {
            console.log('Insurance checkbox not found');
        }
    }, 100); // Small delay to ensure cart is fully loaded
}

// Insurance modal functionality
function initializeInsuranceModal() {
    // Modal elements
    const CSmodal = document.getElementById("cs-modal-1605");
    const CScloseButton = document.getElementById("cs-close-1605");
    const CSinfoButton = document.getElementById("cs-info-button-1605");

    // Check if all required elements exist
    if (!CSmodal || !CScloseButton || !CSinfoButton) {
        console.error('Required modal elements not found');
        return;
    }

    // Initialize modal as hidden
    CSmodal.classList.add('cs-closed');
    CSmodal.classList.remove('cs-loaded');
    CSmodal.style.zIndex = -10000;

    // Information button event listener
    CSinfoButton.addEventListener('click', function () {
        // Show the modal when info button is clicked
        CSmodal.classList.remove('cs-closed');
        CSmodal.classList.add('cs-loaded');
        CSmodal.style.zIndex = 999999999999;
    });

    // Close button event listener
    CScloseButton.addEventListener('click', function () {
        // Hide the modal
        CSmodal.classList.add('cs-closed');
        CSmodal.classList.remove('cs-loaded');
        CSmodal.style.zIndex = -10000;

        // Store the closed state in localStorage (optional - for session tracking)
        localStorage.setItem('modalClosed', 'true');
    });
}


// Local storage reset for testing - uncomment to reset modal state
// localStorage.setItem('modalClosed', 'false');
